import React from "react";
import { Navigate, useParams } from "react-router-dom";
import {
  TOOL_PREP_ENTRY,
  isToolPrepKey,
  writeToolPrepSession,
} from "../../utils/editorEntrySession";
import { isAiToolComingSoon } from "../../config/dashboard/trendingToolsConfig";
import { clearAuthReturnPath } from "../../utils/authReturnPath";

/**
 * Deep-link entry for /tools/:toolKey.
 * Redirects onto Dashboard with openToolPrep state so the host page
 * stays mounted when the prep overlay closes.
 */
const ToolPrepWorkspace = () => {
  const { toolKey } = useParams();

  clearAuthReturnPath();

  if (!isToolPrepKey(toolKey) || isAiToolComingSoon(toolKey)) {
    return <Navigate to="/dashboard" replace />;
  }

  try {
    writeToolPrepSession({
      toolPrep: toolKey,
      entryMode: TOOL_PREP_ENTRY.DASHBOARD,
    });
  } catch {
    // ignore
  }

  return (
    <Navigate
      to="/dashboard"
      replace
      state={{
        openToolPrep: toolKey,
        toolPrepEntryMode: TOOL_PREP_ENTRY.DASHBOARD,
      }}
    />
  );
};

export default ToolPrepWorkspace;
